/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "583558e65d8e25806457a83ff5af0587eea83d50";
